import { render, staticRenderFns } from "./EzSortableHeader.vue?vue&type=template&id=9e2d4dba&scoped=true&"
import script from "./EzSortableHeader.vue?vue&type=script&lang=js&"
export * from "./EzSortableHeader.vue?vue&type=script&lang=js&"
import style0 from "./EzSortableHeader.vue?vue&type=style&index=0&id=9e2d4dba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2d4dba",
  null
  
)

export default component.exports